import { render, staticRenderFns } from "./MaintenanceGridItem.vue?vue&type=template&id=5afb6fe4&scoped=true&"
import script from "./MaintenanceGridItem.vue?vue&type=script&lang=ts&"
export * from "./MaintenanceGridItem.vue?vue&type=script&lang=ts&"
import style0 from "./MaintenanceGridItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afb6fe4",
  null
  
)

export default component.exports